<template>
  <app-accordion class="mb-4">
    <template v-slot:title>
      <span class="item-location">{{ location.location }}</span>
    </template>
    <template v-slot:content>
      <ul class="item-location-list-item">
        <li v-for="item in location.items" :key="item.id">
          {{ item.name }}
        </li>
      </ul>
    </template>
  </app-accordion>
</template>

<script>
import AppAccordion from "@/components/base/app-accordion/AppAccordion";

export default {
  name: "LocationListItem",
  components: {
    AppAccordion
  },
  props: {
    location: Object
  }
};
</script>

<style scoped lang="scss">
.item-location-list-item {
  list-style: none;
  font-size: 13px;
  margin: 8px;
  padding: 0 0 0 15px;
}
</style>
